module.exports = __webpack_public_path__ + "1812026585475e88e3e65a0faea35e48.png";